export const getHeroContent = () => ({
  title: "Transforming Operations Through Advanced Technology Solutions",
  description:
    "Empowering both private businesses and government agencies with innovative system-based solutions that optimize data management and enhance operational efficiency. Our commitment to customized technology drives a more efficient, data‑driven future for our nation.",
  backgroundImage: "/assets/images/bg1.jpg",
  sideImage: "/assets/images/HomeImage.png",
});

export const getSolutions = () => [
  {
    title: "Human Resource Information System (HRIS)",
    subtitle: "Civil Service Commission Prime",
    description:
      "A comprehensive suite of modules designed to streamline and enhance every aspect of HR operations. From Records Management and Organizational Staffing to Payroll, Timekeeping, Learning, and Performance Monitoring — our system empowers your team with efficient tools for employee development, recognition, and self-service access.",
    icon: "bi-people-fill",
    image: "/assets/images/solution1.jpg",
  },
  {
    title: "Document Management System (DMS)",
    description:
      "Simplifies Document Processing, Accounts and Records Management, Workflow Management, and more. With powerful dashboards and system controls, you’ll gain efficiency, accuracy, and actionable insights at every level.",
    icon: "bi-folder2-open",
    image: "/assets/images/solution1.jpg",
  },
  {
    title: "Barangay Information System (BIS)",
    description:
      "Integrates essential modules for Resident Management, Incident Reporting, Service Tracking, Communication, Request Management, and Analytics — delivering efficient and responsive community management.",
    icon: "bi-house-door",
    image: "/assets/images/solution1.jpg",
  },
];

export function getBottomSection() {
  return {
    subtitle: "Driving Innovation, Powering Progress",
    title: "Your trusted partner in transformative technology",
    description:
      "We help businesses and government agencies streamline processes, boost efficiency, and embrace a data-driven future. Together, we build solutions that drive growth and national advancement.",
    image: "/assets/images/Footer.png",
  };
}

export const getExtraSectionContent = () => ({
  image: "/assets/images/team-of-Filipino.jpg",
  heading: "Empowering Progress through Innovative Technology",
  paragraph:
    "We aim to deliver innovative technological solutions that empower businesses and government bodies to streamline processes, enhance operational efficiency, and thrive in a data-driven world. We aim to support your organization whether you're looking to optimize existing systems or embark on a complete digital transformation journey, with tailored solutions designed to meet your unique objectives and contribute to national progress.",
});

export const getFooterContent = () => ({
  backgroundColor: "#96B596",
  text: "© 2025 Tenth Corporation Inc. All Rights Reserved",
});
